import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getExpenseCategories,
  getExpenseIncomeCategories,
  getIncomeCategories,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class CategoryDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        id: '',
        name: '',
        type: '',
      },
      loading: false,
      isLoad: true,
    }
  }

  async componentDidMount() {
    this.getCategoryInfo();
  }
  setCategories = async () => {
    const expenseCategories = await getExpenseCategories();
    const incomeCategories = await getIncomeCategories();
    const expenseIncomeCategories = await getExpenseIncomeCategories();
    localStorage.setItem('expenseCategories', JSON.stringify(expenseCategories));
    localStorage.setItem('incomeCategories', JSON.stringify(incomeCategories));
    localStorage.setItem('expenseIncomeCategories', JSON.stringify(expenseIncomeCategories));
  }
  getCategoryInfo = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await apiCall(`business/income-expense-categories/info/${id}`, 'get', null);

      const updatedData = { ...this.state.formData };

      updatedData.id = response.id;
      updatedData.name = response.name;
      updatedData.type = response.type;

      this.setState({ formData: updatedData, isLoad: false });

    } catch (error) {
      console.error('Error fetching role info:', error);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value,
      }
    }));
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    try {
      const response = await apiCall('business/income-expense-categories/update/' + formData.id, 'post', formData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { formData, loading } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateExpenseIncomeCategoryPermission = userPermissions.includes('update expense income category');

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Gelir ve Giderler"
              Breadcrumb={[
                { name: "Gelir ve Giderler", navigate: "receivables" },
                { name: "Kategoriler", navigate: "income-expense-categories" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="card">
                <form onSubmit={this.handleSubmit}>
                  <div className="body">
                    <div className="row clearfix justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <label htmlFor="name" className="font-weight-bold text-cyan">Kategori Adı</label>
                        <div className="form-group">
                          <input
                            id="name"
                            className="form-control"
                            placeholder="Kategori adı"
                            type="text"
                            value={formData.name || ''}
                            onChange={this.handleChange}
                          />
                        </div>
                        <label htmlFor="name" className="font-weight-bold text-cyan">Kategori Tipi</label>
                        <div className="form-group">
                          <select id='type'
                            className="form-control"
                            value={formData.type || ''}
                            onChange={this.handleChange}>
                            <option value="">Tip Seçiniz</option>
                            <option value="Gelir">Gelir</option>
                            <option value="Gider">Gider</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="row clearfix justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        {loading ? (
                          <button className="btn btn-outline-primary btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}>
                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                              height={'24px'}
                              color="#268bd2"></ReactLoading>
                          </button>
                        ) :
                          <button disabled={!userHasUpdateExpenseIncomeCategoryPermission}
                            className="btn btn-outline-primary btn-block"
                            type="submit">
                            Güncelle
                          </button>}

                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(CategoryDetail)));
